import {constructMapOfLabelsValues} from "../charts/BasicAreaDrawer";
import {prepareChartData} from "./HighChartsDrawer";
import {calcChartTitle} from "./HighGaugeDrawer";
import {handleChartClick} from "./HighPieChartDrawer";

/**
 *
 * @param {namaTypes.DTOUserDashbordChartLine} userDashboardChartLine
 * @param h
 * @param w
 * @return {JQuery | jQuery | HTMLElement}
 */
export function createHighBasicAreaChart(userDashboardChartLine, h, w, widget, Highcharts) {
    let seriesData = [];
    let labelWithValues = constructMapOfLabelsValues(userDashboardChartLine);
    for (let [label, values] of labelWithValues.entries()) {
        seriesData.push({name: label, data: values});
    }
    let widgetId = widget.attr('id');
    let chartData = {
        type: 'area',
    };
    chartData = prepareChartData(chartData, w, h);
    Highcharts.chart(widgetId, {
        chart: chartData,
        xAxis: {
            allowDecimals: false,
            labels: {
                formatter: function () {
                    return this.value;
                }
            }
        },
        yAxis: {
            title: {
                text: calcChartTitle(userDashboardChartLine)
            },
            labels: {
                formatter: function () {
                    return this.value / 1000 + 'k';
                }
            }
        },
        tooltip: {
            pointFormat: '{series.name} <b>{point.y}</b>',
            useHTML: true
        },
        plotOptions: {
            area: {
                pointStart: 1940,
                marker: {
                    enabled: false,
                    symbol: 'circle',
                    radius: 2,
                    states: {
                        hover: {
                            enabled: true
                        }
                    }
                },
                point: {
                    events: {
                        click: handleChartClick
                    }
                }
            }
        },
        series: seriesData
    });
}